import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.folhartaxas.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.folhartaxas.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionTabelaPreco = ({dispatch},payload)=>{
    return serves.folhartaxas.tabelapreco(payload).then(res => {
        dispatch('ActionSetTabelaPreco',res)
    }).catch(err => {
        dispatch('ActionSetTabelaPreco',res)
    })
}
export const ActionListaTomador = ({dispatch},payload)=>{
    return serves.comissionado.listatomador(payload).then(res => {
        dispatch('ActionSetListaTomador',res)
    }).catch(err => {
        dispatch('ActionSetListaTomador',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.comissionado.delete(payload).then(res => {
        
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.folhartaxas.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.folhartaxas.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetTabelaPreco = ({commit},payload) =>{
    commit(types.SET_TABELAPRECO,payload)
}
export const ActionSetListaTomador = ({commit},payload) =>{
    commit(types.SET_TOMADORES,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
